export default "__VITE_ASSET__09d02a06__"